module.exports = __webpack_public_path__ + "static/media/green-bg-img.a012eb22.svg";